const helpers = require('./helpers')

function setUpGoogleAnalyticsScripts(ga_id) {
  const externalSrc = '//www.google-analytics.com/analytics.js'
  if (helpers.hasScriptAlreadyLoaded(externalSrc)) {
    return
  }

  window.GoogleAnalyticsObject = 'ga'
  window.ga =
    window.ga ||
    function () {
      ;(window.ga.q = window.ga.q || []).push(arguments)
    }
  window.ga.l = 1 * new Date()

  const script = document.createElement('script')
  script.async = 1
  script.src = externalSrc
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script) // Insert the script into the document head if there's no firstScript.
  }

  if (window.location.hostname === 'localhost') {
    window.ga('create', ga_id, 'none')
  } else {
    window.ga('create', ga_id, 'auto')
  }
  window.ga('require', 'displayfeatures')
}

function setUpGoogleTagManagerScripts(timestamp, gtm) {
  const externalSrc = '//www.googletagmanager.com/gtm.js?id='
  if (helpers.hasScriptAlreadyLoaded(externalSrc)) {
    return
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'gtm.start': timestamp,
    event: 'gtm.js',
  })

  const scriptElement = document.createElement('script')
  scriptElement.async = true
  scriptElement.src = externalSrc + gtm

  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(scriptElement, firstScript)
  } else {
    document.head.appendChild(scriptElement) // Insert the script into the document head if there's no firstScript.
  }
}

// https://developers.google.com/analytics/devguides/collection/analyticsjs/single-page-applications#tracking_virtual_pageviews
function firePageTracking(path) {
  window.ga('set', 'page', path)
  window.ga('send', 'pageview')
}

module.exports = {
  setUpGoogleAnalyticsScripts,
  firePageTracking,
  setUpGoogleTagManagerScripts,
}
